import * as Yup from "yup";

export const addProductSchema = Yup.object().shape({
  productCategoryId: Yup.number().required("لطفا دسته بندی را انتخاب کنید"),
  name: Yup.string().required("لطفا نام محصول را وارد کنید"),
});

export const productTechSpecSchema = Yup.object().shape({
  technicalSpecificationId: Yup.number().required("لطفا ویژگی را انتخاب کنید"),
  value: Yup.string().required("لطفا مقدار را وارد کنید"),
});

export const productRelationsSchema = Yup.object().shape({
  relatedProductId: Yup.number().required("لطفا محصول را انتخاب کنید"),
  description: Yup.string().required("لطفا توضیحات را وارد کنید"),
});

export const productRelationsUpdateSchema = Yup.object().shape({
  title: Yup.string().required("لطفا عنوان را وارد کنید"),
  description: Yup.string().required("لطفا توضیحات را وارد کنید"),
});

export const productPriceRangeSchema = Yup.object().shape({
  pricingMethod: Yup.number(),
  price: Yup.number().when(
    "pricingMethod",
    ([pricingMethod], schema: Yup.NumberSchema) =>
      pricingMethod === 0
        ? Yup.number().required("مبلغ پایه را وارد کنید")
        : schema.nullable()
  ),
  minPrice: Yup.number().when(
    "pricingMethod",
    ([pricingMethod], schema: Yup.NumberSchema): Yup.NumberSchema =>
      pricingMethod === 1
        ? Yup.number().required("مبلغ حداقل را وارد کنید")
        : Yup.number()
  ),
  maxPrice: Yup.number().when(
    "pricingMethod",
    ([pricingMethod], schema: Yup.NumberSchema): Yup.NumberSchema =>
      pricingMethod === 1
        ? Yup.number().required("مبلغ حداکثر را وارد کنید")
        : Yup.number()
  ),
});

export const productDiscountSchema = Yup.object().shape({
  discountType: Yup.number(),
  discount: Yup.number().when(
    "discountType",
    ([discountType], schema: Yup.NumberSchema) =>
      (discountType ?? 0) > 0
        ? Yup.number().required("لطفا مقدار تخفیف را وارد کنید")
        : schema.nullable()
  ),
  discountDescription: Yup.string().when(
    "discountType",
    ([discountType], schema: Yup.StringSchema) =>
      (discountType ?? 0) > 0
        ? Yup.string().required("لطفا علت تخفیف را ذکر کنید")
        : schema.nullable()
  ),
});

export const productCustomerAndShipmentSchema = Yup.object().shape({
  storeId: Yup.number().required("لطفا فروشنده را مشخص کنید"),
  stockCount: Yup.number().nullable(),
  shipmentMethod: Yup.number().nullable(),
  shipmentTime: Yup.number().nullable(),
  shipmentFee: Yup.number().nullable(),
});

// export const productCustomerAndShipmentSchema = Yup.object().shape({
//   storeId: Yup.number().required("لطفا فروشنده را مشخص کنید"),
//   stockCount: Yup.number().required("لطفا موجودی در دسترس را وارد کنید"),
//   shipmentMethod: Yup.number().required(
//     "لطفا نحوه پرداخت هزینه ارسال را مشخص کنید"
//   ),
//   shipmentTime: Yup.number().required("لطفا زمان ارسال را وارد کنید"),
//   shipmentFee: Yup.number().required("لطفا فی ارسال را وارد کنید"),
// });
